import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useParams, Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import IRMenu from "./IRMenu";
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import { Button } from "../../../myfin_v2/elements/Button";
import { PurchaseOfShares, SaleOfShares, Buyback, SubscriptionRights, StockSplit, BonusIssue } from "./components/InvestmentForms";
import { getLinkedCompanies, GetAllCompanyData, createInvestmentTransaction, GetProjectsBasedOnUserId, getAllConsolApi, getInvestmentSummary, getInvestmentRegisterForms } from "../../../../src/WorkSpace/Components/ApiServices/apiHandler";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { ReactComponent as LeftArrowIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon }       from "../../../myfin_v2/assets/icons/dot.svg";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../myfin_v2/elements/ErrorPopup";

const TRANSACTION_COMPONENTS = {
    "Purchase of Shares":                PurchaseOfShares,
    "Sale of Shares to Third Party":     SaleOfShares,
    // "Buyback by Investee from Investor": Buyback,
    // "Subscription to Rights Issue":      SubscriptionRights,
    // "Stock Split by Investee":           StockSplit,
    // "Bonus Issue by Investee":           BonusIssue,
};

const getRelationshipStatus = (percentage) => {
    if (percentage <= 20) return "Investment";
    if (percentage > 20 && percentage < 50) return "Associate";
    if (percentage === 50) return "Joint Venture";
    if (percentage > 50) return "Subsidiary";
};


const CreateInvestment = () => {
    const { registerid } = useParams();
    const history = useHistory();
    const location = useLocation();
    
    // Extract workspace_id from URL path
    const pathArray = location.pathname.split("/");
    const workspace_id = pathArray[2]; // workspace ID is usually at index 2
    
    console.log("URL path:", location.pathname);
    console.log("Workspace ID from URL:", workspace_id);

    const [formData, setFormData]  = useState({});
    const [relationship, setRelationship]  = useState("");
    const [selectedTransaction, setSelectedTransaction] = useState("Purchase of Shares");
    const [companyOptions, setCompanyOptions] = useState([]);
    const [projectOptions, setProjectOptions] = useState([]);
    const [consolList, setConsolList] = useState([]);
    const [loadingCompanies, setLoadingCompanies] = useState(true);
    const [isConsoleEntryOpen, setIsConsoleEntryOpen] = useState(false);
    const [consoleData, setConsoleData] = useState(null);
    const [registerName, setRegisterName] = useState("");
    const [previousShares, setPreviousShares] = useState(0);
    const [currentShares, setCurrentShares] = useState(0);
    const [successPopup, setSuccessPopup] = useState({ isOpen: false, message: "" });
    const [errorPopup, setErrorPopup] = useState({ isOpen: false, message: "" });
    const formatDate = (input) => {
    if (!input) return null;

    if (input.includes("-") && input.split("-")[0].length === 2) {
        return input;
    }

    const d = new Date(input);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
    };
    const [previousOwnership, setPreviousOwnership] = useState(0);
    const [currentOwnership, setCurrentOwnership] = useState(0);
    const safeNumber = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
    };
    useEffect(() => {
        console.log("registerid:", registerid);
        if (!registerid) return;
        setLoadingCompanies(true);
        getInvestmentRegisterForms(registerid)
            .then(res => setRegisterName(res.data?.investmentRegister?.name || "Investment Name"))
            .catch(err => console.error("Failed to fetch register name:", err));
        Promise.all([
            getLinkedCompanies(registerid),
            GetAllCompanyData()
        ])
            .then(([linkedRes, allDataRes]) => {
                const linkedCompanies = linkedRes.data?.companies || [];
                const allCompanyData = allDataRes.data?.getAllCompanyData || [];
                
                const options = linkedCompanies.map((c) => {
                    const fullData = allCompanyData.find(ac => ac._id === c._id);
                    return {
                        value: c._id,
                        label: c.company_name,
                        functional: fullData ? fullData.functional : c.functional,
                    };
                });
                setCompanyOptions(options);
            })
            .catch((err) => {
                console.error("Failed to fetch linked companies:", err);
            })
            .finally(() => setLoadingCompanies(false));
    }, [registerid]);

    useEffect(() => {
    const user_id = localStorage.getItem("user_id");
    if (!user_id) return;
    GetProjectsBasedOnUserId(user_id)
        .then(res => {
            const projects = res.data.result || []; 

            const options = projects.map(p => ({
                value: p._id,
                label: p.project_name,
            }));

            setProjectOptions(options);
        })
        .catch(err => console.error("Failed to fetch projects:", err));
}, []);

useEffect(() => {
    console.log("useEffect - Attempting to fetch consol list");
    console.log("Workspace ID available:", workspace_id);
    
    if (!workspace_id) {
        console.warn("No workspace_id available from URL");
        return;
    }
    
    getAllConsolApi(workspace_id)
        .then(res => {
            console.log("getAllConsol API Response:", res.data);
            const consols = res.data?.consolList || []; 
            console.log("Consols array:", consols);

            const consolOptions = consols.map(c => ({
                value: c._id,
                label: c.name,
            }));
            console.log("Formatted consolOptions:", consolOptions);

            setConsolList(consolOptions);
        })
        .catch(err => console.error("Failed to fetch consol list:", err));
}, [workspace_id]);

useEffect(() => {
    if (!registerid || !formData.investorCompany) {
        setPreviousShares(0);
        setPreviousOwnership(0);
        return;
    }

    getInvestmentRegisterForms(registerid)
        .then((res) => {
            const investments = res.data?.investmentRegister?.investments || [];

            const filtered = investments.filter(
                (t) => t.investorCompanyID === formData.investorCompany
            );

            if (!filtered.length) {
                setPreviousShares(0);
                setPreviousOwnership(0);
                return;
            }

            const sorted = filtered.sort(
                (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
            );

            let totalShares = 0;
            let totalOutstanding = 0;

            sorted.forEach((item) => {
                const purchased = Number(item.noOfSharesPurchased) || 0;
                const sold = Number(item.noOfSharesSold) || 0;

                if (item.natureOfTransaction?.toLowerCase().includes("sale")) {
                    totalShares -= sold;
                } else {
                    totalShares += purchased;
                }

                if (item.totalSharesOutstanding) {
                    totalOutstanding = Number(item.totalSharesOutstanding);
                }
            });

            setPreviousShares(totalShares);

            setPreviousOwnership(
                totalOutstanding
                    ? (totalShares / totalOutstanding) * 100
                    : 0
            );
        })
        .catch(console.error);

}, [registerid, formData.investorCompany]);

useEffect(() => {

    const enteredPurchase = safeNumber(formData.noOfShares);
    const enteredSale = safeNumber(formData.noOfSharesSold);

    const hasInput = enteredPurchase > 0 || enteredSale > 0;

    const totalShares =
        safeNumber(formData.totalSharesOutstanding) ||
        (previousOwnership > 0
            ? (previousShares / previousOwnership) * 100
            : 0);

    let nowShares = 0;

    if (hasInput) {
        nowShares = safeNumber(previousShares);

        if (selectedTransaction === "Purchase of Shares") {
            nowShares += enteredPurchase;
        }

        if (selectedTransaction === "Sale of Shares to Third Party") {
            nowShares -= enteredSale;
        }

        if (nowShares < 0) nowShares = 0;
    }

    setCurrentShares(nowShares);
    if (!hasInput || totalShares <= 0) {
        setCurrentOwnership(0);
        setRelationship("");
        return;
    }

    const nowPercent = (nowShares / totalShares) * 100;

    setCurrentOwnership(safeNumber(nowPercent));

    const status = nowPercent > 0 ? getRelationshipStatus(nowPercent) : "";
    setRelationship(status);

}, [
    formData.noOfShares,
    formData.noOfSharesSold,
    formData.totalSharesOutstanding,
    selectedTransaction,
    previousShares,
    previousOwnership
]);

const shareDifference = safeNumber(currentShares) - safeNumber(previousShares);
const ownershipDifference = safeNumber(currentOwnership) - safeNumber(previousOwnership);
    const handleFieldChange = (field, value) => {
        setFormData(prev => {
            const newData = { ...prev, [field]: value };
            if (field === "investorCompany") {
                const selectedCompany = companyOptions.find(c => c.value === value);
                if (selectedCompany && selectedCompany.functional) {
                    newData.investmentCurrency = selectedCompany.functional;
                } else {
                    newData.investmentCurrency = "";
                }
            }
            return newData;
        });
    };

    const handleTransactionChange = (val) => {
        setSelectedTransaction(val);
        setFormData({});
    };

const handleCreate = () => {
    const isSale = selectedTransaction === "Sale of Shares to Third Party";
    const isConsolType = formData.FSType === "consol";

    const payload = {
        natureOfTransaction:        selectedTransaction,
        transactionDate: formatDate(formData.transactionDate),
        investorCompanyID:          formData.investorCompany,
        investeeCompanyID:          formData.investeeCompany,
        browseControlDateFSType:    formData.FSType || "standalone",
        ...(formData.FSType === "standalone" && {
            browseControlDateFS:    formData.browseControlDateFS || null,
        }),
        ...(isConsolType && {
            browseControlDateConsolID: formData.consolID || null,
        }),
        notesRemarks:               formData.notesRemarks || "",
        isCommonControlTransaction: formData.isCommonControlTransaction || false,
        addOtherDetails:            formData.addOtherDetails || [],
        autoAdjustmentMapping:     formData.autoAdjustmentMapping || [],
        natureOfRelationship:       relationship,
        consolEntry: {
            nonControllingAsset: Number(formData.nciValue) || 0,
            investment:          Number(formData.consolInvestment) || 0,
            goodWill:            Number(formData.goodWill) || 0,
            otherInputs:         Number(formData.otherInputs) || 0,
            netAssets:           Number(formData.netAssets) || 0,
            gainOnBargainPurchase: Number(formData.gainOnBargainPurchase) || 0,
            
        },
        investmentCurrency: formData.investmentCurrency || "USD",

 
        ...(!isSale && {
            classOfShare:              formData.classOfShare,
            noOfSharesPurchased:       Number(formData.noOfShares) || 0,
            purchasePricePerShare:     Number(formData.purchasePricePerShare) || 0,
            totalConsideration:        Number(formData.totalConsideration) || 0,
            totalSharesOutstanding:    Number(formData.totalSharesOutstanding) || 0,
            purchasedFrom:             formData.purchasedFrom || "",
            costBasisMethod:           formData.costBasisMethod || "",
            cashBankPaidUpfront:       Number(formData.cashBankPaid) || 0,
            deferredConsideration:     Number(formData.deferredConsideration) || 0,
            deferredPaymentDate:       formData.deferredPaymentDate || null,
            contingentConsiderationFV: Number(formData.contingentConsideration) || 0,
            contingencyDescription:    formData.contingencyDescription || "",
            maxContingentAmount:       Number(formData.maxContingentAmount) || 0,
            contingentPaymentDate:     formData.contingentPaymentDate || null,
            transactionCosts:          Number(formData.transactionCosts) || 0,
        }),

    
        ...(isSale && {
            noOfSharesSold:      Number(formData.noOfSharesSold) || 0,
            salePricePerShare:   Number(formData.salePricePerShare) || 0,
            totalSaleProceeds:   Number(formData.totalSaleProceeds) || 0,
            costBasisMethod:     formData.costBasisMethod || "",
            costOfSharesSold:    Number(formData.costOfSharesSold) || 0,
            gainOrLossInSale:   Number(formData.gainOrLoss) || 0,
            soldTo:              formData.soldTo || "",
        }),
    };

    console.log("Payload:", payload);
    createInvestmentTransaction(registerid, payload)
        .then(res => {
            console.log("Investment created:", res.data);
            if (res?.data?.success) {
                setSuccessPopup({ isOpen: true, message: res.data?.message || "Investment created successfully" });
            } else {
                history.push(`/detailsIR/${registerid}`);
            }
        })
        .catch(err => {
            console.error("Error creating investment:", err);
            setErrorPopup({
                isOpen: true,
                message: err?.response?.data?.error || err?.response?.data?.message || "Something went wrong ❌",
            });
        });
};
    const ActiveTransaction = TRANSACTION_COMPONENTS[selectedTransaction];

    return (
        <div className={commoncss.pageLayout}>
            <Sidebar />
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu activeTab={"Investments"} registerID={registerid} />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
    
                    <div className={investmentRegisterCss.iDHeader}>
                        <div style={{ display: "flex", alignItems: "center", gap: "15px", fontSize: "14px" }}>
                            <Link to={`/detailsIR/${registerid}`} style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
                                <LeftArrowIcon height={12} style={{ marginBottom: "2px", marginRight: "10px" }} />
                                <span style={{ color: "#4D6D64" }}>Investments</span>
                            </Link>
                            <DotIcon />
                            <span style={{ color: "#4D6D64" }}>{registerName}</span>
                            <DotIcon />
                            <span>Create new investment</span>
                        </div>
                        <Button btnColor={buttoncss.primary} label="Create" onClick={handleCreate} />
                    </div>


                    {loadingCompanies ? (
                        <div style={{ padding: "40px", textAlign: "center", color: "#4D6D64" }}>
                            Loading...
                        </div>
                    ) : (
                        <ActiveTransaction
                            formData={formData}
                            onChange={handleFieldChange}
                            relationship={relationship}
                            onRelChange={setRelationship}
                            companyOptions={companyOptions}
                            projectOptions={projectOptions}
                            consolList={consolList}
                            selectedTransaction={selectedTransaction}
                            onTransactionChange={handleTransactionChange}
                            previousShares={previousShares}
                            currentShares={currentShares}
                            previousOwnership={previousOwnership}
                            currentOwnership={currentOwnership}
                            shareDiff={shareDifference}
                            ownershipDiff={ownershipDifference}
                        />
                    )}

                </motion.div>
            </div>

            <SuccessPopup
                isOpen={successPopup.isOpen}
                message={successPopup.message}
                onClose={() => {
                    setSuccessPopup({ isOpen: false, message: "" });
                    history.push(`/detailsIR/${registerid}`);
                }}
            />
            <ErrorPopup
                isOpen={errorPopup.isOpen}
                message={errorPopup.message}
                onClose={() => setErrorPopup({ isOpen: false, message: "" })}
            />
        </div>
    );
};

export default CreateInvestment;